import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BookmarkPlus, BookmarkCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const parseStreamTitle = (raw) => {
  const text = raw.replace(/\s+/g, " ").trim();
  const sep = text.match(/\s[-–—]\s/);
  if (!sep) return { artist: "Unknown artist", title: text };
  const artist = text.slice(0, sep.index).trim();
  const title = text.slice(sep.index + sep[0].length).trim();
  return artist && title ? { artist, title } : { artist: "Unknown artist", title: text };
};

export const CaptureButton = ({ nowPlaying, station, heardAt, initiallySaved = false, testid = "player-capture-button", onSaved }) => {
  const navigate = useNavigate();
  const [saved, setSaved] = useState(initiallySaved ? { [nowPlaying]: true } : {});
  const done = saved[nowPlaying];
  const capture = async () => {
    const { artist, title } = parseStreamTitle(nowPlaying);
    const when = heardAt ? new Date(heardAt) : new Date();
    try {
      const { data } = await api.post("/wishlist", { items: [{ title, artist, reason: `Heard on ${station} · ${when.toLocaleString([], { dateStyle: "medium", timeStyle: "short" })}`, source: station }] });
      setSaved((s) => ({ ...s, [nowPlaying]: true }));
      onSaved?.();
      toast.success(data.added ? "Saved to wishlist" : "Already on your wishlist", {
        description: `${title} — ${artist}`, action: { label: "View", onClick: () => navigate("/wishlist") },
      });
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <button onClick={capture} disabled={done} data-testid={testid} title={done ? "On your wishlist" : "Save this song to your wishlist"}
      className={`shrink-0 rounded-full p-2 transition-colors ${done ? "text-amber-600" : "text-zinc-500 hover:bg-amber-50 hover:text-amber-700"}`}>
      {done ? <BookmarkCheck size={16} /> : <BookmarkPlus size={16} />}
    </button>
  );
};
